module.exports = __webpack_public_path__ + "static/media/TB new header.a625f08d.png";